import { IconV3, IconV3Props, RpiLabelText } from "@rpi/openapi-core";
import { getRoutePath, NavRouteLink, RoutePathsKeys } from "../../hooks/useNavigateRoute";
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { useNavBarButtonStyles } from "./NavBarStyles";

const useStyles = createStyles(() => ({
  navButtonLink: {
    "&:active": {
      color: tokens.color.semantic.text.linkActive,
    },
    "&:hover": {
      color: tokens.color.semantic.text.linkHover,
      backgroundColor: tokens.color.semantic.bg.primarySubtlest,
    },
    "&.active": {
      color: tokens.color.semantic.text.primary,
      backgroundColor: tokens.color.semantic.bg.primarySubtlest,
      "font-weight": tokens.font.weight.semibold,
    },
  },
}));

interface NavBarButtonProps {
  name: string;
  route: RoutePathsKeys;
  icon: IconV3Props["icon"];
}

export const NavBarButton: React.FC<NavBarButtonProps> = ({ name, route, icon }) => {
  const { classes: sharedClasses, cx } = useNavBarButtonStyles();
  const { classes } = useStyles();

  return (
    <NavRouteLink
      to={getRoutePath(route)}
      end={route === "home"}
      className={cx(sharedClasses.navButton, classes.navButtonLink)}
      aria-label={name}
      tabIndex={0}
    >
      <IconV3 icon={icon} size={20} color="currentColor" aria-hidden="true" />
      <span className={sharedClasses.navButtonText}>
        <RpiLabelText>{name}</RpiLabelText>
      </span>
    </NavRouteLink>
  );
};
